import { FC, useCallback, useMemo } from 'react';
import styled from 'styled-components';

import { Field } from '../../types/form-fields';
import { isTextField } from '../../components/form-editor/text-field';
import { STANDALONE_LANDING_URL, WIX_APP_MARKET_LINK } from '../../config';
import { getUserPlan, useUser } from '../../lib';

type BrandingProps = {
  formFields: Field[];
  showBranding?: boolean;
  wixInstanceId?: string;
};

export const Branding: FC<BrandingProps> = ({ formFields, showBranding, wixInstanceId }) => {
  const { user } = useUser();
  const userPlan = getUserPlan(user);

  const getBrandingColor = useCallback(() => {
    let color = '';

    formFields.forEach((field) => {
      if (!color && isTextField(field)) {
        color = field.color;
      }
    });

    return color || '#fff';
  }, [formFields]);

  const brandingColor = useMemo(() => getBrandingColor(), [getBrandingColor]);

  const getShowBranding = (): boolean => {
    if (user) {
      return ['free', 'basic'].includes(userPlan);
    }

    return Boolean(showBranding);
  };

  if (!getShowBranding()) {
    return null;
  }

  return (
    <BrandingWrapper color={brandingColor}>
      Made by{' '}
      <BrandingLink
        target="_blank"
        rel="noopener noreferrer"
        color={brandingColor}
        href={wixInstanceId ? WIX_APP_MARKET_LINK : STANDALONE_LANDING_URL}
      >
        Popup Games
      </BrandingLink>
    </BrandingWrapper>
  );
};

const BrandingWrapper = styled.div<{ color: string }>`
  margin-top: 24px;
  align-self: flex-end;
  color: ${(p) => p.color};
  font-size: 12px;
`;

const BrandingLink = styled.a`
  color: ${(p) => p.color};

  :visited,
  :hover,
  :active {
    color: ${(p) => p.color};
    text-decoration: underline;
    cursor: pointer;
  }
`;
